import axios from "axios";
import useSWR from "swr";

const defaultTheme = {
  title: "Low-carbon technologies projects",
  disclaimer: null,
};

const fetcher = (url) =>
  axios.get(url).then((res) => {
    return res.data;
  });

export default function useTheme() {
  const { data, errors } = useSWR(
    `${window?.__env__?.WP_SOURCE}/wp-json/gip/v2/options`,
    fetcher
  );
  return {
    ...defaultTheme,
    ...data,
  };
}
